<template>
  <div class="account-open-container">
    <van-form @submit="onSubmit" scroll-to-error>
      <van-field
        v-model="form.realName"
        maxlength="50"
        name="realName"
        label="真实姓名"
        placeholder="请输入真实姓名"
        :rules="[{ required: true }]"
      />
      <van-field name="gender" label="性别" :rules="[{ required: true, message: '请选择性别' }]">
        <template #input>
          <van-radio-group v-model="form.gender" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.address"
        maxlength="200"
        name="address"
        label="地址"
        placeholder="请输入地址"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="form.idCard"
        maxlength="200"
        name="idCard"
        label="身份证号"
        placeholder="请输入身份证号"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="form.phone"
        maxlength="200"
        name="phone"
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ required: true }]"
      />
      <van-field
        readonly
        clickable
        name="bankId"
        :value="bankName"
        label="开户银行"
        placeholder="请点击选择开户银行"
        @click="showBankList = true"
        :rules="[{ required: true }]"
      />
      <van-field
        readonly
        clickable
        name="showAreaText"
        :value="showAreaText"
        label="开户行所在地"
        placeholder="请点击选择开户行所在地"
        @click="showAddressList = true"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="form.bankAcctNum"
        maxlength="200"
        name="bankAcctNum"
        label="银行卡号"
        placeholder="请输入银行卡号"
        :rules="[{ required: true }]"
      />

      <footer class="open-buttons">
        <button class="left" @click="$router.go(-1)">取消</button>
        <button class="right" native-type="submit">立即开通</button>
      </footer>
    </van-form>

    <van-popup v-model="showBankList" position="bottom">
      <div class="top-tool-bar">
        <div class="cancel" @click="onCancelBank">取消</div>
        <div class="confirm" @click="onConfirmBank">确定</div>
      </div>
      <van-search
        v-model="searchBankWorld"
        placeholder="请输入搜索开户行"
        @search="onBankSearch"
        @cancel="onBankSearchCancel"
      />
      <div class="tip">如果列表中没有您的的开户银行，请选择搜索</div>
      <van-picker :columns="bankShowList" value-key="name" ref="bankPick" />
    </van-popup>
    <van-popup v-model="showAddressList" position="bottom">
      <van-picker
        show-toolbar
        :columns="areaList"
        value-key="name"
        @change="areaSelectChanged"
        @confirm="onAreaConfirm"
        @cancel="showAddressList = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { bankList, provinceList, cityList, accountCreate } from '@/api/capital';
import { Toast } from 'vant';
export default {
  data() {
    return {
      showBankList: false, // 开户银行
      showAddressList: false,
      bankName: '',
      showAreaText: '',
      searchBankWorld: '', // 搜索银行关键字
      allBankList: [],
      areaList: [{ values: [] }, { values: [] }],
      form: {
        shopType: 0,
        realName: '',
        gender: 1,
        idCard: '',
        phone: '',
        bankId: '',
        address: '',
        bankAcctNum: null,
        bankProv: null,
        bankArea: null,
      },
    };
  },
  created() {
    this.loadBankList();
    this.getprovinceList();
  },
  methods: {
    loadBankList() {
      bankList().then(res => {
        // this.bankList = res.data.list;
        this.bankShowList = this.spliceArr(res.data.list);
        this.allBankList = Object.freeze(res.data.list);
        console.log(this.allBankList);
      });
    },
    spliceArr(data) {
      let arr = [];
      data.map((v, index) => {
        if (this.form.bankId == v.code) {
          arr.push(v);
        } else if (index < 30) {
          arr.push(v);
        }
      });
      return arr;
    },
    onBankSearch(value) {
      if (value) {
        this.bankShowList = this.allBankList.filter(item => {
          return item.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
        this.$forceUpdate();
      } else {
        this.bankShowList = this.spliceArr(this.allBankList);
        this.$forceUpdate();
      }
    },

    onBankSearchCancel() {
      this.bankShowList = this.spliceArr(this.allBankList);
      this.$forceUpdate();
    },

    onConfirmBank() {
      let values = this.$refs.bankPick.getValues();
      if (values && values.length > 0) {
        const pick = values[0];
        this.showBankList = false;
        this.bankName = pick.name;
        this.form.bankId = pick.code;
      } else {
        Toast('请选择数据');
      }
    },
    onCancelBank() {
      this.showBankList = false;
    },

    getprovinceList() {
      provinceList().then(res => {
        console.log(res);
        this.areaList[0].values = res.data.list;
        this.getcity(res.data.list[0].code);
      });
    },
    areaSelectChanged(pick, value, index) {
      if (index === 0) {
        const province = value[0];
        if (province && province.code) {
          this.getcity(province.code);
        }
      }
    },
    getcity(code) {
      cityList({ pCode: code }).then(res => {
        console.log(res);
        this.areaList[1].values = res.data.list;
      });
    },
    onAreaConfirm(pick, value) {
      this.showAddressList = false;
      if (pick[0].name && pick[1].name) {
        this.showAreaText = `${pick[0].name}/${pick[1].name}`;
        this.form.bankProv = pick[0].code;
        this.form.bankArea = pick[1].code;
      } else {
        this.showAreaText = null;
        this.form.bankProv = null;
        this.form.bankArea = null;
      }
    },

    onSubmit(value) {
      Toast.loading({
        message: '开通中...',
        forbidClick: true,
      });
      accountCreate(this.form)
        .then(res => {
          Toast.clear(false);
          this.$router.go(-1);
        })
        .finally(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.account-open-container {
  padding-top: 10px;
  width: 100%;
  position: relative;
  min-height: 100vh;
  .tip {
    color: #999;
    font-size: 13px;
    margin: 10px;
  }
  .top-tool-bar {
    width: 100%;
    height: 44px;
    line-height: 44px;
    display: flex;
    justify-content: space-between;

    .cancel {
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: #969799;
    }
    .confirm {
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      color: #576b95;
    }
  }
}
.open-buttons {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  height: 58px;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: content-box;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  font-size: 14px;
  text-align: center;
  .left {
    flex: 1;
    height: 44px;
    line-height: 44px;
    color: #222222;
    border: 1px solid #222222;
    border-radius: 4px;
    background: white;
  }
  .right {
    flex: 1;
    height: 44px;
    line-height: 44px;
    color: white;
    background-color: #222222;
    margin-left: 15px;
    border-radius: 4px;
  }
}
</style>
